import { cn, toFixedTwo } from '@/lib/utils';
import EnrichedAmount from '@/assets/icons/enrichedAmount.svg?react';
import Forward from '@/assets/icons/Forward.svg?react';
import SingleReceipt from '@/assets/icons/single_receipt.svg?react';
import EnrichedReceipt from '@/assets/icons/enriched_receipt.svg?react';
import { Link } from 'wouter';
import { components } from '@/types/api';
import { useMemo } from 'react';
import { isAfter, subDays, format } from 'date-fns';

export default function ReceiptItem({ receipt }: { receipt: components['schemas']['Receipt'] }) {
  const dayOfWeek = useMemo(() => {
    const today = new Date();
    const date = new Date(receipt.created_at);
    return isAfter(date, subDays(today, 7)) ? format(date, 'EEEE') : format(date, 'MM/dd/yy');
  }, [receipt.created_at]);

  return (
    <Link href={`/receipts/${receipt.id}`}>
      <div className="flex cursor-pointer items-center justify-between border-b border-gray-100 py-1.5">
        <div className="flex items-center space-x-3">
          {receipt.total_benefit !== '0.00' && receipt.status !== 'review_requested' ? (
            <EnrichedReceipt />
          ) : (
            <div className="bg-primary-platinum flex h-8 w-8 shrink-0 items-center justify-center rounded">
              <SingleReceipt />
            </div>
          )}
          <div>
            <p className="max-w-[200px] truncate text-base font-medium">{receipt.merchant_name}</p>
            <div className="flex flex-row gap-1">
              <p className="text-xs opacity-70">{dayOfWeek}</p>
              {receipt.status && (
                <span
                  className={cn('inline-flex items-center rounded px-2 py-0.5 text-xs', {
                    'bg-primary-blue-light text-primary': receipt.status === 'checking',
                    'bg-secondary-light':
                      receipt.status === 'review_requested' || receipt.status === 'in_review',
                  })}
                >
                  {receipt.status === 'checking' && 'Checking eligibility'}
                  {(receipt.status === 'review_requested' || receipt.status === 'in_review') && (
                    <>In review</>
                  )}
                </span>
              )}
            </div>
          </div>
        </div>
        <div className="flex items-center space-x-3">
          <div className="flex flex-col items-center">
            <span
              className={cn('text-base', {
                'font-bold':
                  receipt.total_benefit !== '0.00' && receipt.status !== 'review_requested',
              })}
            >
              {receipt.transaction_amount && `$${toFixedTwo(receipt.transaction_amount)}`}
            </span>
            {receipt.total_benefit !== '0.00' && receipt.status !== 'review_requested' && (
              <span className="text-primary flex flex-row items-center gap-1 text-xs font-semibold">
                ${receipt.total_benefit} <EnrichedAmount />
              </span>
            )}
          </div>
          <Forward />
        </div>
      </div>
    </Link>
  );
}
